import { useState } from 'react';
import { Box, Button, Divider, Stack, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { CloseDocumentModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/CloseDocumentModal';

interface Props {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}

export const CloseDocumentSection = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<>
			<Divider color="gray.2" />
			<Stack gap="sm">
				<Text c="gray.9" size="0.875rem">
					{tMipManage('documents_page.close_document.section.title')}
				</Text>
				<Box
					p="md"
					sx={(theme) => ({
						border: `1px solid ${theme.colors.gray[2]}`,
						borderRadius: theme.radius.sm,
					})}
				>
					<Stack gap="md">
						<Text size="0.875rem" c="gray.7" lh={1.5}>
							{tMipManage('documents_page.close_document.section.description')}
						</Text>
						<Button
							variant="default"
							size="md"
							leftSection={<Icon variant="document-v3" size="md" />}
							onClick={() => setIsModalOpen(true)}
							fullWidth
							styles={(theme) => ({
								root: {
									borderColor: theme.colors.gray[2],
									color: theme.colors.dark[9],
									fontWeight: 600,
								},
							})}
						>
							{tMipManage('documents_page.close_document.section.button')}
						</Button>
					</Stack>
				</Box>
			</Stack>
			<CloseDocumentModal
				dealId={dealId}
				programmeId={programmeId}
				documentWorkflowInstanceId={documentWorkflowInstanceId}
				opened={isModalOpen}
				onClose={() => setIsModalOpen(false)}
			/>
		</>
	);
};
